// removed by extract-text-webpack-plugin
module.exports = {"moduleSectionContent":"KlXfl_Nq0vVNyi7LIkU2t","detailsContainer":"_2ZqK4M7sIV6YlsoYq5fQ2J","keyValueColumn":"_2_4iRyHsf8F_kIPVZmSUHo","keyValuePair":"_186ia1gptRbJ2evzVhaith","keyCont":"_3Jep3S5VHR9ZP5garsS_Oa","key":"_1QFxmP5qjg9qa9N5uhBoX_","valCont":"_2aKsuNo0BQeA8rSizW1FuT","value":"_2adx7PGTyvADkq79fMJdbj","divider":"_1jhviCIReVqLnB-_hO9Vpm"};


//////////////////
// WEBPACK FOOTER
// ./components/KeyValue.scss
// module id = 1583
// module chunks = 0